import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShippingtermService } from './shippingterm.service';
import { SetupService } from '../setup.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainComponent } from 'src/app/app.main.component';
import { FormGroup,FormBuilder,Validators } from '@angular/forms';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import {ObjectNames,Status,Severity,Answer} from '../../constants/constants';
import { TitleCasePipe } from '@angular/common';
@Component({
  selector: 'app-shippingterm',
  templateUrl: './shippingterm.component.html',
  styleUrls: ['./shippingterm.component.scss']
})
export class ShippingtermComponent implements OnInit, OnDestroy {

  shippingTermForm:FormGroup;
  allShippingTerms: any[]=[];
  addEditShippingTermHeader: string;
  displayShippingTermAdd:boolean=false;
  isAddShippingTerm:boolean=false;
  invalidData:boolean=false;
  statusConstants= Status;
  answertypeConstants= Answer;
  statusDisabled: boolean=false;

  constructor(private shippingtermService: ShippingtermService, private confirmationService: ConfirmationService, private messageService: MessageService,
    private fb: FormBuilder, private app: AppMainComponent, private setupService: SetupService, private yearPipe: AddYearPipe,
    private titlecasePipe: TitleCasePipe) { }

  ngOnInit(): void {

    this.setupService.getShippingTerm().subscribe(term => {
      if (term) {
        this.showAddShippingTerm();
      }
    })

    this.shippingTermForm = this.fb.group({
      id: [0],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [''],
      updatedBy: [''],
      createdDate: [''],
      updatedDate: [''],
      organizationId: [''],
      name: ['',[Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      statusId: [true],
      isValid: [true],
      validFromDate: [''],
      isDefault: [false],
      validToDate: [''],
    });
    this.loadShippingTerms();
  }

  loadShippingTerms() {
    this.shippingtermService.getShippingTermList().subscribe((terms) => {
      this.allShippingTerms = terms;
    })
  }

  showAddShippingTerm(){
    this.addEditShippingTermHeader = ObjectNames.setupConstants.AddShippingTermTitle;
    this.displayShippingTermAdd = true;
    this.statusDisabled =false;
    this.invalidData=false;
    this.isAddShippingTerm=true;
    this.shippingTermForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: ['',[Validators.required,Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      statusId: [true],
      isValid: [true],
      isDefault: [false],
      validFromDate: [new Date().toISOString()],
      validToDate: [this.yearPipe.transform(new Date())],
    });
  }

  showEditShippingTerm(term) {
    this.addEditShippingTermHeader = ObjectNames.setupConstants.EditShippingTermTitle;
    this.displayShippingTermAdd = true;
    this.invalidData=false;
    this.isAddShippingTerm=false;
    this.shippingTermForm.patchValue(term);
    this.shippingTermForm.controls['statusId'].setValue(term.statusId==Status.ACTIVE?true:false);
    if(term.isDefault){
      this.statusDisabled=true;
    }else{
      this.statusDisabled=false;
    }
  }

  checkShippingTermStatus() {
    if (!this.isAddShippingTerm && !this.shippingTermForm.controls['statusId'].value) {
      this.setupService.checkDeleteStatus(this.shippingTermForm.controls['id'].value,'shippingTerm').subscribe(check => {
        if (!check.item1) {
         return
        }else{
          this.shippingTermForm.get("statusId").setValue(true);
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `${check.item2}` });
        }
      })
    }
  }

  checkDeleteStatus(term) {
    this.setupService.checkDeleteStatus(term.id,'shippingTerm').subscribe(check => {
      if (!check.item1) {
        this.deleteShippingTerm(term);
      }else{
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `${check.item2}` });
      }
    })
  }

  deleteShippingTerm(term) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Shipping Term?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.shippingtermService.deleteShippingTerm(term.id).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          const index = this.allShippingTerms.indexOf(term);
          this.allShippingTerms.splice(index, 1);
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  shippingTermDefault(term){
    this.allShippingTerms.forEach(element => {
      if(element.id!=term.id){
        element.isDefault=false;
      }
    });
   this.isAddShippingTerm=false;
   this.saveShippingTerm(term);
  }

  saveShippingTerm(value){
    this.invalidData=false;
    //Status 1-Active.2-InActive
    value.statusId=(value.statusId==true?Status.ACTIVE:Status.INACTIVE);
    //console.log(value);
    const lowerCaseNames=[];
    if (this.isAddShippingTerm) {
      for (let s of this.allShippingTerms) {
        lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ''))
      }
      if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, '')) > -1) {
        this.invalidData = true;
      } else {
        this.shippingtermService.addShippingTerm(value).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Shipping Term Added successfully...' });
          this.loadShippingTerms();
          this.displayShippingTermAdd = false;
        }).catch(() => {
          this.displayShippingTermAdd = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }
    } else {
      const duplicateRecord = this.allShippingTerms.find(depOb => depOb.name.toLowerCase().replace(/ /g, '') == value.name.toLowerCase().replace(/ /g, '') && depOb.id !== value.id)
      if (duplicateRecord) {
        this.invalidData = true;
      } else {
        this.invalidData=false;
        value.updatedBy = this.app.userId;
        value.updatedDate = new Date().toISOString();
        value.updatedSource = this.app.userIP;
        this.shippingtermService.updateShippingTerm(value).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Shipping Term Updated successfully...' });
          this.loadShippingTerms();
          this.displayShippingTermAdd = false;
        }).catch(() => {
          this.displayShippingTermAdd = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }

    }

  }

  ngOnDestroy(): void 
  {
    this.setupService.setShippingTerm('');
  }

}
